import React, { useEffect, useState, useContext, useRef } from "react";
// UNINSTALL- Added but not --saved
import * as Yup from "yup";
import axios from "axios";
import { useHistory, Link } from "react-router-dom";
import { AuthContext } from "../helpers/AuthContext";

import MyInstancesLeftSidebar from "../pages/essentials/MainDashboardLeftSidear";
import PageHeaderWithBreadcrumbs from "../components/PageHeaderWithBreadcrumbs";
import { useStripe, CardCvcElement, useElements } from "@stripe/react-stripe-js";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { format } from "date-fns";
import { ToastContainer, toast } from 'react-toastify'

/* ICONS */
import TitleIcon from '@mui/icons-material/Title';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import ForumIcon from '@mui/icons-material/Forum';
import BrushIcon from '@mui/icons-material/Brush';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import { getBrowserTimeZone, listSupportedTimeZones } from "../utils/timezone";

function LaunchInstance() {
  const { authState } = useContext(AuthContext);
  const [typeOfIndustry, setTypeOfIndustry] = useState('promo-company')
  const [paymentMethods, setPaymentMethods] = useState(null);
  const [paymentMethodForPurchase, setPaymentMethodForPurchase] = useState('')
  const [loading, setLoading] = useState(true);
  const [noPaymentsLoading, setNoPaymentsLoading] = useState(true);
  const [typeOfCore, setTypeOfLiveChat] = useState("promo-company");
  const [timezone, setTimezone] = useState(getBrowserTimeZone());
  const timeZoneOptions = listSupportedTimeZones();


  const initialValues = {
    title: "",
    instanceUniqueId: "",
    typeOfIndustry: "",
  };

  const handleTypeOfLiveChatChange = e => {
    e.persist();
    setTypeOfLiveChat(e.target.value);
  };

  const stripe = useStripe();
  const elements = useElements();
  const [cvcError, setCvcError] = useState(null);

  let history = useHistory();

  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      history.push("/login");
    } else {
      axios
        .get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/${authState.id}/retrieve-payment-methods`, {
          headers: { accessToken: localStorage.getItem("accessToken") },
        })
        .then((response) => {
          if(response.data.data != ""){
            setPaymentMethods(response.data.data);
            setLoading(false)
          }
        }).catch((err) => {
          setNoPaymentsLoading(false)
        })
    }
  }, [authState.id]);

  const onSubmit = (data) => {
    // Verify unique core ID doesn't already exist
    axios
    .get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/verifyinstanceUniqueIdexists`, {
      params: {
        instanceUniqueIdToCheck: data.instanceUniqueId
      }
    }).then(instanceUniqueIdStatus => {
      // If the email exists
      if(instanceUniqueIdStatus.data == true){
        toast.error("The unique core ID provided is already in use.", {
          toastId: 1
        })
      // If the email doesn't exist
      } else if (instanceUniqueIdStatus.data == false){
        if(paymentMethodForPurchase != ""){
          axios
          .get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/retrieve-payment-method`, {
            headers: { 
              accessToken: localStorage.getItem("accessToken") 
            },
            params: {
              selectedPaymentMethod: paymentMethodForPurchase
            },
          })
          .then((paymentMethodResponse) => {
            stripe
            .createToken("cvc_update", elements.getElement(CardCvcElement)).then((tokenResult) => {
              if (tokenResult.error) {
                setCvcError(tokenResult.error.message);
              } else {
                axios.post(`${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/create-payment-intents`, { 
                  userId: authState.id,
                  paymentMethod: paymentMethodResponse.data,
                  createStripeCustomerAccount: false
                }).then((paymentStatus) => {
                    toast.success("The card payment was successful.", {
                      toastId: 2
                    })
                    const newInstanceData = new FormData()
                    newInstanceData.append('instanceName', data.title)
                    newInstanceData.append('emailAddress', authState.email)
                    newInstanceData.append('instanceUniqueId', data.instanceUniqueId.toLowerCase())
                    newInstanceData.append('typeOfIndustry', typeOfIndustry)
                    newInstanceData.append('typeOfCore', typeOfCore)
                    newInstanceData.append('timezone', timezone)
                    newInstanceData.append("contactEmails", JSON.stringify({contact_emails: authState.email}))
                    newInstanceData.append('stripeCustomerId', paymentStatus.data.StripeUserId)
                    newInstanceData.append('activeStatus', "active") 
                    newInstanceData.append('chatInstanceCounter', 1)     
                    var meggedObj = {}
                    // add the form key/value pairs
                    for (var pair of newInstanceData.entries()) {
                      meggedObj[pair[0]] = pair[1];
                    }
                    axios
                      .post(`${process.env.REACT_APP_NODEJS_SERVER_URL}/instances`, meggedObj, {
                        headers: { 
                          accessToken: localStorage.getItem("accessToken"),
                        }
                      })
                      .then((response) => {
                        history.push("/");
                      });
                  })
                  .catch((err) => {
                    toast.error("The card payment was unsuccessful. Please retry.", {
                      toastId: 3
                    })
                  });
              }
            })
          });
        } else {
          toast.error("You must select a credit card to proceed.", {
            toastId: 6
          })
        }
      }
    })
  };

  const instanceUniqueIdRegExp = /^[\a-zA-Z-]+$/
  const validationSchema = Yup.object().shape({
    title: 
    Yup.string()
      .min(3, "Your business name must be a minimum of 3 characters.")
      .max(80, "Your business name must be a maximum of 80 characters.")
      .matches(/^[-a-zA-Z0-9-()]+(\s+[-a-zA-Z0-9-()]+)*$/, "Your business name may only contain letters and numbers.")
      .required("A business name is required.")
      .typeError("You must assign a business name that is between 3 to 50 characters."),
    instanceUniqueId: 
    Yup.string()
      .min(3, "Your unique core ID must be a minimum of 3 characters.")
      .max(30, "Your unique core ID must be a maximum of 30 characters.")
      .matches(instanceUniqueIdRegExp, "Your unique core ID must only contain letters and dashes.")
      .required("A unique core ID is required.")
      .typeError("Your unique core id must not contain spaces or special characters and be between 4 to 20 characters.")
  });

  return (
    <div className="ec-app-instances">
    <MyInstancesLeftSidebar/>
    <ToastContainer/>
    <div className="rightSide">
    { loading == false ?
      paymentMethods != null ?
      <div className="options-container launch-instance fade-in-effect-usability">
        <div className="options-inner-container">
        <Formik 
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          <Form className="form-design-settings">
          <PageHeaderWithBreadcrumbs title="Purchase a new core." breadcrumb="Purchase a shop"/>
          <fieldset>
            <div className="field-column-half">
              <div className="field-column-inner">
                <label>What is the name of your business? <span className="required-mark">*</span></label>
                <ErrorMessage name="title" component="span"/>
                <Field
                  autocomplete="off"
                  id="inputCreatePost"
                  name="title"
                  placeholder="My Live Core"
                />
              </div>
            </div>
            <div className="field-column-half">
              <div className="field-column-inner">
                <label>Unique core ID <span className="required-mark">*</span></label>
                <div className="whats-this">
                  <LiveHelpIcon/>
                  <div className="whats-this-explaination">
                    <p>Your unique core ID is used to track every core that is launched. This field is not displayed to visitors, it is purely used as a method of tracking. For example, if your business was called "Elite Core", an ideal unique core ID would be "elite-core"</p>
                  </div>
                </div>
                <ErrorMessage name="instanceUniqueId" component="span" />
                <Field
                  autocomplete="off"
                  id="inputCreatePost"
                  name="instanceUniqueId"
                  placeholder="my-live-core"
                />
              </div>
            </div>
          </fieldset>

          { /* TYPE OF LIVE CORE SELECTION */ }

          <fieldset>
            <div className="field-column-inner">
            <div className="radioSelection" role="group" aria-labelledby="my-radio-group">
            <label id="my-radio-group"><ForumIcon></ForumIcon> Which type of live core, would you like to launch?</label>

            <div className="relativeRadioImage">

            <img className="radio-icons" src="/elite-core-icons/core-selection-promo-company.png"/>

              <label>
              <Field
                value="promo-company"
                type="radio"
                aria-label="userHasSelectedAvatar"
                label="Avatar"
                className="radio-input-50"
                onChange={handleTypeOfLiveChatChange}
                checked={ typeOfCore === "promo-company"}
              />
              <span className="radio-text-50">Promo company</span>
              <span className="radio-text-pricing-line-2">$99/monthly</span>

              </label>
              
              </div>

            </div>
          </div>
          </fieldset>
          
          <fieldset>
            <div className="field-column-inner">
            <label><LocationCityIcon></LocationCityIcon> Which industry best relates to your live core?</label>
            <ErrorMessage name="typeOfIndustry" component="span" />
            <Field value={typeOfIndustry} as="select" name="typeOfIndustry" onChange={(e) => setTypeOfIndustry(e.target.value)}>
              <option value="promotional-award">Promotional wear</option>
              <option value="awards-and-trophies">Awards & Trophies</option>
              <option value="reseller-group">Reseller Group</option>
              <option value="other">Other</option>
            </Field>
            </div>
          </fieldset>

          <fieldset>
            <div className="field-column-inner">
            <label><LocationCityIcon></LocationCityIcon> Company timezone</label>
            <Field as="select" name="timezone" value={timezone} onChange={(e) => setTimezone(e.target.value)}>
              {timeZoneOptions.map((timeZoneValue) => (
                <option key={timeZoneValue} value={timeZoneValue}>{timeZoneValue}</option>
              ))}
            </Field>
            </div>
          </fieldset>

          <fieldset className="payment-method-fieldset">
            <div className="select-a-payment-method">
            <ErrorMessage name="typeOfIndustry" component="span" />
            <label><CreditCardIcon/> Select a payment method </label>
            <Field as="select" name="selectedPaymentMethod" onChange={(e) => setPaymentMethodForPurchase(e.target.value)}>
              <option disabled selected>Please select your preferred credit card.</option>
              {paymentMethods ?
                paymentMethods.map((method) => (
                  <option value={method.id}>{method.card.brand} **** {method.card.last4} | Expires{" "} {format(new Date(`${method.card.exp_year}/${method.card.exp_month}/01`), "MM/yyyy")}</option>
                ))
              : ""
              }
            </Field>
            </div>
          <div className="field-column-inner stripe-cvc-element">
            <label>Associated CVC <span className="required-mark">*</span></label>
            <CardCvcElement
              onChange={() => {
                setCvcError(null);
              }}
            />
            {cvcError}
          </div>
        </fieldset>
        <div className="payment-confirmation">
          <h2>Confirm payment.</h2>
            <p className="registerForm-cta-paragraph">Upon clicking confirm, your selected payment card will be charged <strong>$99</strong> as a standard initilization fee. By clicking confirm, you agree to our terms and conditions.</p>
            <div className="browse-cart">
              <span className="item-cost">$99 support core initialization <b>x1</b></span>
            </div> 
          </div>    

          <button className="elite-btn" type="submit"> Create instance</button>
      </Form>
      </Formik>
      </div>
      </div>
        :
        ""
        : 
        noPaymentsLoading == false ?
        <div className="options-container fade-in-effect-usability">
          <div className="options-inner-container">
            <div className="options options-no-header-or-footer">
              <h2>No payment methods</h2>
              <p>You must add a payment method to your first live core before you are able to launch any more instances. <Link to="/">Click here to return to your main dashboard</Link>, and select the "Add to site" or "Get started" options under your first live core. </p>
            </div>
          </div>
        </div>  
        : "" 
        }
      </div>
    </div>
  );
}

export default LaunchInstance;
